import { gql } from '@apollo/client';

export const SEARCH_SCHOOL_SUBJECTS_QUERY = gql`
  query SearchSchoolSubjects($term: String!, $locale: String) {
    searchSchoolSubjects(term: $term, locale: $locale)
  }
`;
